import React, { useState } from 'react';
import Rating from '../Rating';

export default function Testimonial() {
  const [activeTab, setActiveTab] = useState(2);
  const handleTabClick = tabNumber => {
    setActiveTab(tabNumber);
  };
  return (
    <div className="cs_tabs cs_style1">
      <ul className="cs_tab_links">
        <li className={activeTab === 1 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(1)}>
            <div className="cs_testimonial_1_avatar">
              <img src="/images/home_1/avatar_1.png" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">MARC DUPONT</h3>
                <p className="cs_heading_color mb-0">Paris 16e</p>
              </div>
            </div>
          </div>
        </li>
        <li className={activeTab === 2 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(2)}>
            <div className="cs_testimonial_1_avatar">
              <img src="/images/home_1/avatar_2.png" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">SOPHIE MARTIN</h3>
                <p className="cs_heading_color mb-0">Boulogne-Billancourt</p>
              </div>
            </div>
          </div>
        </li>
        <li className={activeTab === 3 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(3)}>
            <div className="cs_testimonial_1_avatar">
              <img src="/images/home_1/avatar_3.png" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">JEAN LEFÈVRE</h3>
                <p className="cs_heading_color mb-0">Neuilly-sur-Seine</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div className="cs_tab_body">
        {activeTab === 1 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>
              Suivi pour une hypertension, j’ai bénéficié d’une consultation
              claire et d’une échographie cardiaque le jour même. Les résultats
              m’ont été expliqués sans jargon, avec un plan de prévention
              concret. Je me sens enfin accompagné pour protéger mon cœur.
            </p>
            <Rating ratingNumber={5} />
          </div>
        )}
        {activeTab === 2 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>
              Des palpitations m’inquiétaient depuis des semaines. Le Holter ECG
              posé à l’ICVT a permis d’identifier le trouble du rythme. L’équipe
              a été rassurante, précise, et le rendez-vous sur Doctolib très
              simple. Un vrai soulagement.
            </p>
            <Rating ratingNumber={4.5} />
          </div>
        )}
        {activeTab === 3 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>
              Bilan cardiovasculaire avant de reprendre le sport : ECG, test
              d’effort, consignes claires. Le cardiologue a pris le temps
              d’écouter et d’adapter le suivi à mon rythme. Professionnalisme et
              humanité, comme on l’attend d’un institut cardiaque.
            </p>
            <Rating ratingNumber={4.5} />
          </div>
        )}
      </div>
    </div>
  );
}
